import React from 'react';
import { Grid } from 'semantic-ui-react';

export default () => (
  <Grid style={{ padding: '1em' }}>
    <Grid.Row only='computer tablet'>
      <Grid.Column computer={8} tablet={8} mobile={16} />
      <Grid.Column width={3} textAlign='right'>
        <strong>Price</strong>
      </Grid.Column>
      <Grid.Column width={2} textAlign='right'>
        <strong>Qty</strong>
      </Grid.Column>
      <Grid.Column width={3} textAlign='right'>
        <strong>Total</strong>
      </Grid.Column>
    </Grid.Row>
  </Grid>
);



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/LineItems/LineItemsHeader.js